var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-form',{ref:"commondForm",attrs:{"lazy-validation":true}},[_vm._t("data")],2),_c('CommonConfirmationModal',{attrs:{"dialog":_vm.dialog},on:{"userChoice":_vm.userChoice}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }